"use strict";
/**
 * Arbitrage monitor UI state helpers
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPairBuilderSearch = setPairBuilderSearch;
exports.setPairBuilderSelection = setPairBuilderSelection;
exports.setPairBuilderMarkets = setPairBuilderMarkets;
exports.updatePairBuilderState = updatePairBuilderState;
exports.setMonitorStatus = setMonitorStatus;
const state_1 = require("../state");
function setPairBuilderSearch(search) {
    (0, state_1.updateState)({
        pairBuilder: {
            ...(0, state_1.getState)().pairBuilder,
            search,
        },
    });
}
function setPairBuilderSelection(selection) {
    (0, state_1.updateState)({
        pairBuilder: {
            ...(0, state_1.getState)().pairBuilder,
            ...selection,
        },
    });
}
function setPairBuilderMarkets(markets) {
    (0, state_1.updateState)({
        pairBuilder: {
            ...(0, state_1.getState)().pairBuilder,
            ...markets,
        },
    });
}
function updatePairBuilderState(update) {
    (0, state_1.updateState)({
        pairBuilder: {
            ...(0, state_1.getState)().pairBuilder,
            ...update,
        },
    });
}
function setMonitorStatus(update) {
    (0, state_1.updateState)({
        monitorStatus: {
            ...(0, state_1.getState)().monitorStatus,
            ...update,
        },
    });
}
